enum ExpenseReportStatus {
  Draft = 'Draft',
  PendingApproval = 'Pending Approval',
  NeedInfo = 'Need Info',
  Rejected = 'Rejected',
  Approved = 'Approved',
  PaidInFull = 'Paid in Full',
}
export default ExpenseReportStatus;
